export default {
  // Search related
  searchPlaceholder: "Search address/hash/investigation user ID",
  dataDetails: "Data Details",

  // Page title
  transactionDetails: "Transaction Details",

  // Buttons
  joinCanvas: "Add to Canvas",
  browserView: "View in Browser",
  addRemark: "Click to add remark",
  reset: "Reset",
  query: "Query",
  downloadDetails: "Download Details",

  // Transaction information
  sender: "Sender",
  receiver: "Receiver",
  interactor: "Interactor",
  smartContract: "Smart Contract",
  transactionTime: "Transaction Time",
  transactionAmount: "Transaction Amount",
  transactionFee: "Transaction Fee",

  // Table related
  tokenTransfer: "Token Transfer",
  senderAddress: "Sender Address",
  receiverAddress: "Receiver Address",
  pleaseSelect: "Please select",
  currency: "Currency",
  amount: "Amount",

  // Loading and status
  loading: "Loading...",
  noData: "No data",

  // Message prompts
  addressNotFound: "Address not found",

  // Download file name
  dataDetailsFileName: "Data Details",

  // Data statistics
  totalDataPrefix: "Total ",
  totalDataSuffix: " records",
  downloadLimit: "Note: Maximum 10,000 records can be downloaded",

  // Note
  note: "Note:",
};
